var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((16),function(item){return _c('ContactTab',{key:item.id})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }